export function horizontalLoop(items, config) {
	let timeline;
	items = gsap.utils.toArray(items);
	config = config || {};
	gsap.context(() => { 
		let onChange = config.onChange,
		lastIndex = 0,
		tl = gsap.timeline({repeat: config.repeat, onUpdate: onChange && function() {
			let i = tl.closestIndex();
			if (lastIndex !== i) {
				lastIndex = i;
				onChange(items[i], i);
			}
			}, paused: config.paused, defaults: {ease: "none"}, onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)}),
		length = items.length,
		startX = items[0].offsetLeft,
		times = [],
		widths = [],
		spaceBefore = [],
		xPercents = [],
		curIndex = 0,
		indexIsDirty = false,
		center = config.center,
		pixelsPerSecond = (config.speed || 1) * 100,
		dragScale = (config.dragScale || 0.6),
		snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
		timeOffset = 0,
		container = center === true ? items[0].parentNode : gsap.utils.toArray(center)[0] || items[0].parentNode,
		totalWidth,
		getTotalWidth = () => items[length-1].offsetLeft + xPercents[length-1] / 100 * widths[length-1] - startX + spaceBefore[0] + items[length-1].offsetWidth * gsap.getProperty(items[length-1], "scaleX") + (parseFloat(config.paddingRight) || 0),
		populateWidths = () => {
			let b1 = container.getBoundingClientRect(), b2;
			items.forEach((el, i) => {
			widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
			xPercents[i] = snap(parseFloat(gsap.getProperty(el, "x", "px")) / widths[i] * 100 + gsap.getProperty(el, "xPercent"));
			b2 = el.getBoundingClientRect();
			spaceBefore[i] = b2.left - (i ? b1.right : b1.left);
			b1 = b2;
			});
			gsap.set(items, { // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
			xPercent: i => xPercents[i]
			});
			totalWidth = getTotalWidth();
		},
		timeWrap,
		populateOffsets = () => {
			timeOffset = center ? tl.duration() * (container.offsetWidth / 2) / totalWidth : 0;
			center && times.forEach((t, i) => {
			times[i] = timeWrap(tl.labels["label" + i] + tl.duration() * widths[i] / 2 / totalWidth - timeOffset);
			});
		},
		getClosest = (values, value, wrap) => {
			let i = values.length,
			closest = 1e10,
			index = 0, d;
			while (i--) {
			d = Math.abs(values[i] - value);
			if (d > wrap / 2) {
				d = wrap - d;
			}
			if (d < closest) {
				closest = d;
				index = i;
			}
			}
			return index;
		},
		populateTimeline = () => {
			let i, item, curX, distanceToStart, distanceToLoop;
			tl.clear();
			for (i = 0; i < length; i++) {
			item = items[i];
			curX = xPercents[i] / 100 * widths[i];
			distanceToStart = item.offsetLeft + curX - startX + spaceBefore[0];
			distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
			tl.to(item, {xPercent: snap((curX - distanceToLoop) / widths[i] * 100), duration: distanceToLoop / pixelsPerSecond}, 0)
				.fromTo(item, {xPercent: snap((curX - distanceToLoop + totalWidth) / widths[i] * 100)}, {xPercent: xPercents[i], duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond, immediateRender: false}, distanceToLoop / pixelsPerSecond)
				.add("label" + i, distanceToStart / pixelsPerSecond);
			times[i] = distanceToStart / pixelsPerSecond;
			}
			timeWrap = gsap.utils.wrap(0, tl.duration());
		},
		refresh = (deep) => {
			let progress = tl.progress();
			tl.progress(0, true);
			populateWidths();
			deep && populateTimeline();
			populateOffsets();
			deep && tl.draggable ? tl.time(times[curIndex], true) : tl.progress(progress, true);
		},
		onResize = () => refresh(true),
		proxy;
		gsap.set(items, {x: 0});
		populateWidths();
		populateTimeline();
		populateOffsets();
		window.addEventListener("resize", onResize);
		function toIndex(index, vars) {
		vars = vars || {};
		(Math.abs(index - curIndex) > length / 2) && (index += index > curIndex ? -length : length); // always go in the shortest direction
		let newIndex = gsap.utils.wrap(0, length, index),
			time = times[newIndex];
		if (time > tl.time() !== index > curIndex && index !== curIndex) { // if we're wrapping the timeline's playhead, make the proper adjustments
			time += tl.duration() * (index > curIndex ? 1 : -1);
		}
		if (time < 0 || time > tl.duration()) {
			vars.modifiers = {time: timeWrap};
		}
		curIndex = newIndex;
		vars.overwrite = true;
		gsap.killTweensOf(proxy);    
		if (vars.duration === 0) {
			return tl.time(timeWrap(time));
		}
		const originalOnComplete = vars.onComplete;
		const tween = tl.tweenTo(time, vars);
		tween.eventCallback("onComplete", () => {
			// Hard snap to the exact label time to avoid fractional drift between slides
			tl.time(timeWrap(time));
			if (typeof originalOnComplete === "function") {
				originalOnComplete();
			}
		});
		return tween;
		}
		tl.toIndex = (index, vars) => toIndex(index, vars);
		tl.closestIndex = setCurrent => {
		let index = getClosest(times, tl.time(), tl.duration());
		if (setCurrent) {
			curIndex = index;
			indexIsDirty = false;
		}
		return index;
		};
		tl.current = () => indexIsDirty ? tl.closestIndex(true) : curIndex;
		tl.next = vars => toIndex(tl.current()+1, vars);
		tl.previous = vars => toIndex(tl.current()-1, vars);
		tl.times = times;
		tl.progress(1, true).progress(0, true); // pre-render for performance
		if (config.reversed) {
		tl.vars.onReverseComplete();
		tl.reverse();
		}
		if (config.draggable && typeof(Draggable) === "function") {
		proxy = document.createElement("div")
		let wrap = gsap.utils.wrap(0, 1),
			ratio, startProgress, draggable, dragSnap, lastSnap, initChangeX, wasPlaying,
			align = () => tl.progress(wrap(startProgress + (draggable.startX - draggable.x) * ratio * dragScale)),
			syncIndex = () => tl.closestIndex(true);
		typeof(InertiaPlugin) === "undefined" && console.warn("InertiaPlugin required for momentum-based scrolling and snapping. https://greensock.com/club");
		draggable = Draggable.create(proxy, {
			trigger: items[0].parentNode,
			type: "x",
			dragResistance: (config.dragResistance != null ? config.dragResistance : 0.35),
			allowNativeTouchScrolling: true,
			lockAxis: true,
			minimumMovement: Math.max(14, config.minimumMovement || 0),
			onDragStart() {
			let x = this.x;
			gsap.killTweensOf(tl);
			wasPlaying = !tl.paused();
			tl.pause();
			startProgress = tl.progress();
			refresh();
			ratio = 1 / totalWidth;
			initChangeX = (startProgress / -ratio / dragScale) - x;
			gsap.set(proxy, {x: startProgress / -ratio / dragScale});
			},
			onDrag: align,
			onThrowUpdate: align,
			overshootTolerance: 0,
			inertia: true,
			snap(value) {
			if (Math.abs(startProgress / -ratio / dragScale - this.x) < 10) {
				return lastSnap + initChangeX
			}
			let time = -(value * ratio * dragScale) * tl.duration(),
				wrappedTime = timeWrap(time),
				snapTime = times[getClosest(times, wrappedTime, tl.duration())],
				dif = snapTime - wrappedTime;
			Math.abs(dif) > tl.duration() / 2 && (dif += dif < 0 ? tl.duration() : -tl.duration());
			lastSnap = (time + dif) / tl.duration() / -ratio / dragScale;
			return lastSnap;
			},
			onRelease() {
				syncIndex();
				if (draggable.isThrowing) {
					indexIsDirty = true;
				} else {
					tl.toIndex(curIndex, { ease: "power3", duration: 0.35, onComplete: () => { if (wasPlaying) tl.play(); } });
				}
			},
			onThrowComplete: () => {
			syncIndex();
			tl.toIndex(curIndex, { duration: 0 });
			wasPlaying && tl.play();
			}
		})[0];
		tl.draggable = draggable;
		}
		tl.closestIndex(true);
		lastIndex = curIndex;
		onChange && onChange(items[curIndex], curIndex);
		timeline = tl;
		return () => window.removeEventListener("resize", onResize); 
	});
	return timeline;
}
	